export { default as asyncImport } from './asyncImport'
export { default as date } from './date'
// http和https转换
export const protocolFixed = str => {
  const reg = /^(http|https):/
  const protocol = document.location.protocol
  // 为了避免将不支持安全协议的第三方强制替换，设置需要替换的白名单列表
  const whitelist =
    /(sina\.com|sina\.cn|weibo\.com|weibo\.cn|sinaimg\.com|sinaimg\.cn)/
  // 同时，即使命中了上面的白名单，也有一些不需要/不能替换，可以合并成同一个正则表达式，为了清晰，拆成允许/不允许的两部分
  const blacklist = /all\.vic\.sina\.com\.cn/
  if (reg.test(str) && whitelist.test(str) && !blacklist.test(str)) {
    str = str.replace(reg, protocol)
  }
  return str
}

/**
 * 获取url传过来的参数
 * @param name 	获取的参数
 * @param url 		自定义获取参数的链接
 * @param return
 */
export const getUrlQuery = (name, url) => {
  // URL GET 获取值
  const reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
  url = decodeURIComponent(url || location.href).split(/#/gi)[0]
  if (reg.test(url)) {
    return RegExp.$2.replace(/\+/g, ' ')
  }
  return ''
}

/**
 * 获取cookie
 * @param {String} name			cookie值
 * @param return 					为了区分没有设置null 与 设置了空值''
 */
export const getCookie = (name = '') => {
  if (!name) {
    return null
  }
  const arr = document.cookie.match(
    new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  )
  if (arr != null) {
    return unescape(arr[2])
  }
  return null
}

/** 分页列表计算是否还可以加载 */
export const listCanLoadMore = ({ pz, pg = 1, total = 0 }) => {
  pz = Number(pz)
  pg = Number(pg)
  total = Number(total)
  return pz * pg < total
}

/** 控制页面滚动 */
export const setPageScroll = (enable = true) => {
  let body = document.body.style
  let html = document.getElementsByTagName('html')[0].style
  if (enable) {
    body.overflow = ''
    html.overflow = ''
  } else {
    body.overflow = 'hidden'
    html.overflow = 'hidden'
  }
}

/**
 * 图片下载（兼容非同源）
 * @param {String} imgsrc 图片url
 * @param {String} name 下载名称
 */
export const downloadImage = (imgsrc, name = '社会化营销案例库') => {
  //下载图片地址和图片名
  let image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
    let a = document.createElement('a') // 生成一个a元素
    let event = new MouseEvent('click') // 创建一个单击事件
    a.download = name // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgsrc
}

/**
 * 下载文件
 * @param {String} url 文件url
 */
export const doDownload = url => {
  if (!url) return
  if (typeof window.DOWNLOAD_IFRAME == 'undefined') {
    const iframe = document.createElement('iframe')
    window.DOWNLOAD_IFRAME = iframe
    document.body.appendChild(window.DOWNLOAD_IFRAME)
    window.DOWNLOAD_IFRAME.style.display = 'none'
  }

  window.DOWNLOAD_IFRAME.src = url
}
